/**
 * The "Monthly / Yearly" segmented control from the toolbar — Yearly always
 * carries a "Save 20%" chip so the saving is asserted on the control itself,
 * not just implied by the per-column struck-through price.
 */
import React from "react";
import classNames from "classnames";
import styles from "./IntervalToggle.module.scss";

const IntervalToggle = ({ interval, onChange }) => (
  <div className={styles.seg} role="tablist" aria-label="Billing interval">
    <button
      type="button"
      role="tab"
      aria-selected={interval === "month"}
      className={classNames(styles.option, { [styles.on]: interval === "month" })}
      onClick={() => onChange("month")}
    >
      Monthly
    </button>
    <button
      type="button"
      role="tab"
      aria-selected={interval === "year"}
      className={classNames(styles.option, { [styles.on]: interval === "year" })}
      onClick={() => onChange("year")}
    >
      Yearly
      <span className={styles.save}>Save 20%</span>
    </button>
  </div>
);

export default IntervalToggle;
